import styles from "./Example.module.css";

interface Props {
    text: string;
    value: string;
    onClick: (value: string) => void;
}

export const Example = ({text, value, onClick}: Props) => {
    return (
        <div
            className={"rounded-lg cursor-pointer bg-stone-50 p-4 text-xs sm:text-sm hover:ring-1 w-full h-full ring-green-500 shadow-sm flex items-center"}
            onClick={() => onClick(value)}>
            <p className="whitespace-pre-line">{text}</p>
        </div>
    );
};
